export const setCookie = (name, value, options) => {
	let updatedCookie;
	options = options || {};
	options.path = options.path || "/";
	if (options.expires instanceof Date) {
		options.expires = options.expires.toUTCString();
	}

	updatedCookie = encodeURIComponent(name) + "=" + encodeURIComponent(value);

	for (var optionKey in options) {
		var optionValue = options[optionKey];
	 	updatedCookie += "; " + optionKey;
	 	if (optionValue !== true) {
	 		updatedCookie += "=" + optionValue;
	 	}
	}

	document.cookie = updatedCookie;
};

export const getCookie = (name) => {
	const matches = document.cookie.match(new RegExp("(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"));
	return matches ? decodeURIComponent(matches[1]) : undefined;
};


export const deleteCookie = (name) => {
	setCookie(name, "", {
		'max-age': -1
	});
};
